import React, {useState, useContext, useEffect, useRef} from "react";
import Modal from "react-bootstrap/Modal";
import "./pin.scss";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {ADMIN_ROLES, TOGGLE_TEST_PIN_URL} from "../../api/urls";
import { toast } from "react-toastify";
import api from "../../api/axios";
import AuthContext from "../../context/AuthProvider";
import {useMediaQuery} from "react-responsive";
import {IconContext} from "react-icons";
import {FaThumbtack} from "react-icons/fa";
import {PrimaryButton} from "../button";
import {updatePastquestion} from "../../store/slices/examSlice";

export const PinExam = ({ isPinned,id}) => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

  const togglePin = async () => {
    try {
        setLoading(true);
        const response = await api.post(`${TOGGLE_TEST_PIN_URL}/${id}`,{
          mode: isPinned?0:1
        });
        dispatch(updatePastquestion({id,flag: !isPinned}));
    } catch (error) {
      toast.error(error.response.data.error);
    }
    setLoading(false);
  };

  return (
    <>
      <div className="pin-div">
        {" "}
        <PrimaryButton onClick={togglePin} isLoading={loading}  className={`pbtn`} size="sm">
          <IconContext.Provider value={{ color: isPinned?"red":"#dfdbdb", className: "ttFav" }}>
          <div className="pinFav">
            <FaThumbtack/>
          </div>
        </IconContext.Provider>
        </PrimaryButton>
      </div>
    </>
  );
};
